import React, { Component } from "react";
import Concert from "./concert";
import "./concert.css";

import ScrollIndicator from "./ScrollIndicator.jsx";

/* Here is what is displayed on top, first of all */
const openingSection = (
  <div className="program-heading">
    <center>
      <h1>Varmt välkomna till Folkmusikkaféet</h1>
      Vi är en mötesplats för levande folkmusik och dans i Göteborg.
      <br />
      Folkmusik och dans varje fredag.
      <br />
      <br />
      <small>
        Bli medlem och få rabatt på inträdet. Du bidrar till att vi finns!
        <br />
        Du blir medlem i entrén på en konsertkväll
        <br /> eller genom att sätta in 50 kr på PG 107741-1, alt. Swish
        1236279434. <br />
        Ange namn, adress, telefonnummer och e-postadress.
        <br />
        Medlemskap gäller per kalenderår.
        <br />
        <br />
        Konsertbiljetter köpes i entrén. Ungdomar och studenter får rabatt.
        Efter avslutad konsert får alla det lägre entrépriset. Ingen förbokning,
        förutom de kvällar där det står ”För den här kvällen finns förköp”.
        <br />
        Spel och danskvällarna, heldanskvällen och spelmansstämman har Fri
        entré.
        <br />
      </small>
    </center>
  </div>
);

/* Here the program is inserted! */
const theProgram = [
  <Concert
    title="Spel- och danskväll"
    date="2026-01-23"
    cost={0}
    img="img/program/vt2026/mams_paps.jpg"
    imgTwo="img/program/vt2026/tageloco.jpg"
  >
    <div className="pBody">
      <center>
        Frivillig entréavgift.
        <br />
        <br />
        Folkmusikkaféet inleder vårsäsongen med en spel- och danskväll – dans
        till spellista. Tre grupper är bokade att inleda kvällen, sedan är det
        fritt fram att skriva upp sig på listan.
        <br />
        <br />
        <table className="program-tabell">
          <tr>
            <td>17:30–19:15</td>
            <td>Kurs: Spelmanslaget</td>
          </tr>
          <tr>
            <td>18:00–19:30</td>
            <td>Tillsammansgruppen</td>
          </tr>
          <tr>
            <td>18:30–19:30</td>
            <td>Dansstuga</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>
                Mats Nilsson och Ingegerd Sigfridsson lär ut grundpolska.
                Spelman: Staffan Folestad.
              </small>
            </td>
          </tr>
          <tr>
            <td>18:30–19:30</td>
            <td>Spelstuga</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>Håkan Bengtsson lär ut hälsingelåtar.</small>
            </td>
          </tr>
          <tr>
            <td>20:00–23:00</td>
            <td>Spel till dans</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>
                Alingsåsfolk, <s>Fredrik Persson</s>, Mams &amp; Paps och Tagel
                &amp; Co inleder, sedan följer öppen spellista.
              </small>
            </td>
          </tr>
        </table>
        <br />
        <small>Kafévärd denna afton: Polskedanslaget</small>
      </center>
    </div>
  </Concert>,

  <Concert
    title="Stordanskväll: Mats Berglund &amp; Göran Håkansson"
    date="2026-01-30"
    cost={160}
    costYoung={85}
    img="img/program/vt2026/mats_goran.jpg"
  >
    <div className="pBody">
      <center>
        Dans hela kvällen! Mats och Göran varvar duospel och solospel så att det
        blir dansmusik utan avbrott i tre timmar.
        <br />
        <br />
        Flera av de mest betydande spelmännen i Värmland växte upp under
        1970-talet och började att spela i det som i historieskrivningen kallas
        för ”Folkmusikvågen”. I ett projekt som hade målsättningen att sätta
        ljus på musiken och dansen i gränsbygderna Värmland och Hedmark började
        Mats Berglund och Göran Håkansson att spela tillsammans.
        <br />
        <br />
        Stordanskvällen på Allégården sätter genom Mats och Görans dansmusik ett
        extra ljus på musiken efter de tidiga föregångarna på Finnskogen:
        Lomjansguten och Haltegutten.
        <br />
        <br />
        <table className="program-tabell">
          <tr>
            <td>17:30–19:15</td>
            <td>Kurs: Spelmanslaget</td>
          </tr>
          <tr>
            <td>18:00–19:30</td>
            <td>Danskurs för nybörjare</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>(se kursinfo)</small>
            </td>
          </tr>
          <tr>
            <td>18:30–19:30</td>
            <td>Dansstuga</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>
                Malte Hermansson och Kerstin Harvenberg lär ut finnskogspols.
                Spelman: Joar Skorpen.
              </small>
            </td>
          </tr>
          <tr>
            <td>18:30–19:30</td>
            <td>Visstuga</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>Åsa Grogarn Sol lär ut obegripliga visor.</small>
            </td>
          </tr>
          <tr>
            <td>20:00–23:00</td>
            <td>Spel till dans</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>Mats Berglund &amp; Göran Håkansson</small>
            </td>
          </tr>
        </table>
        <br />
        <small>Kafévärd denna afton: GNDS</small>
      </center>
    </div>
  </Concert>,

  <Concert
    title="Anna &amp; Ale Möller"
    date="2026-02-06"
    cost={160}
    costYoung={85}
    img="img/program/vt2026/anna_ale_moller.jpg"
  >
    <div className="pBody">
      <center>
        Två generationer A. Möller bjuder på favoriter ur låtrepertoaren! Inte
        minst en drös både spelade och ospelade Möller-låtar hörs när
        familjeduon sömlöst rör sig mellan stilar, stämningar och ljudvärldar.
        Ett bokstavligen livslångt samspel som är personligt, dynamiskt,
        kärleksfullt och svängigt.
        <br />
        <br />
        <b>
          OBS! För den här kvällen finns förköp via Billetto (avgift
          tillkommer).
        </b>
        <br />
        <br />
        <table className="program-tabell">
          <tr>
            <td>17:30–19:15</td>
            <td>Kurs: Spelmanslaget</td>
          </tr>
          <tr>
            <td>18:00–19:30</td>
            <td>Danskurs för nybörjare</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>(se kursinfo)</small>
            </td>
          </tr>
          <tr>
            <td>18:30–19:30</td>
            <td>Dansstuga</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>
                Ingela och Håkan Lindberg lär ut sønderhoning. Spelman: Björn
                Johnsson.
              </small>
            </td>
          </tr>
          <tr>
            <td>18:30–19:30</td>
            <td>Visstuga</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>Ann-Britt Lindhult lär ut visor från Västergötland.</small>
            </td>
          </tr>
          <tr>
            <td>20:00–21:00</td>
            <td>Konsert: Anna &amp; Ale Möller</td>
          </tr>
          <tr>
            <td>21:00–23:00</td>
            <td>Spel till dans</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>Anna &amp; Ale Möller</small>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>
                I pausen leder Tommy Tannerud och Biörn Landahl långdans och
                balladdans
              </small>
            </td>
          </tr>
        </table>
        <br />
        <small>Kafévärd denna afton: Styrelsen + medarbetare</small>
      </center>
    </div>
  </Concert>,

  <Concert
    title="Jakob Ainegren &amp; William Olsson"
    date="2026-02-13"
    cost={160}
    costYoung={85}
  img="img/program/vt2026/Jakob_Ainegren.jpg"
  imgTwo="img/program/vt2026/William_Olsson.jpg"
  >
    <div className="pBody">
      <center>
Ändrade planer- men bra planer! Den här kvällen skulle vi ha fått höra Jakob Ainegren och Joel Andersson, men Joel har tyvärr blivit sjuk. Vi har dock hittat en bra ersättare - William Olsson. William är en multi-instrumentalist som trakterar klarinett, durspel, fiol och många olika typer av flöjter. Jakob, en aktiv violinmakare, spelar fiol. Tillsammans bjuder de på värmländska låtar.
        <br />
        <br />
        <table className="program-tabell">
          <tr>
            <td>17:30–19:15</td>
            <td>Kurs: Spelmanslaget</td>
          </tr>
          <tr>
            <td>18:00–19:30</td>
            <td>Danskurs för nybörjare</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>(se kursinfo)</small>
            </td>
          </tr>
          <tr>
            <td>18:30–19:30</td>
            <td>Dansstuga</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>
                Emelie Ström Mattsson och Alice Carlström lär ut bakmes och
                slängpolska från övre Klarälvsdalen. Spelman: Lars-Gunnar
                Franzén
              </small>
            </td>
          </tr>
          <tr>
            <td>18:30–19:30</td>
            <td>Spelstuga</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>Hans Grönlund lär ut låtar från Värmland</small>
            </td>
          </tr>
          <tr>
            <td>20:00–20:50</td>
            <td>Konsert: Jakob Ainegren &amp; Joel Andersson</td>
          </tr>
          <tr>
            <td>20:50–23:00</td>
            <td>Spel till dans</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>Jakob Ainegren &amp; Joel Andersson</small>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>I pausen spelar Kråkstråk</small>
            </td>
          </tr>
        </table>
        <br />
        <small>Kafévärd denna afton: Styrelsen + medarbetare</small>
      </center>
    </div>
  </Concert>,

  <Concert
    title="Spel- och danskväll"
    date="2026-02-20"
    cost={0}
    img="img/program/vt2026/spel_och_dans_feb.jpg"
  >
    <div className="pBody">
      <center>
        Frivillig entréavgift.
        <br />
        <br />
        På en spel- och danskväll är det dans till spellista. Vi har bokat musik
        som inleder kvällen, sedan är det fritt fram att skriva upp sig på
        listan.
        <br />
        <br />
        <table className="program-tabell">
          <tr>
            <td>17:30–19:15</td>
            <td>Kurs: Spelmanslaget</td>
          </tr>
          <tr>
            <td>18:00–19:30</td>
            <td>Tillsammansgruppen</td>
          </tr>
          <tr>
            <td>18:00–19:30</td>
            <td>Danskurs för nybörjare</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>(se kursinfo)</small>
            </td>
          </tr>
          <tr>
            <td>18:30–19:30</td>
            <td>Visstuga</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>Anders Ström lär ut isländska visor</small>
            </td>
          </tr>
          <tr>
            <td>20:00–23:00</td>
            <td>Spel till dans</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>
                Bagaregårdens spelmanlag, Victor Andersson och Mimmie Törngren
                inleder, sedan följer öppen spellista
              </small>
            </td>
          </tr>
        </table>
        <br />
        <small>Kafévärd denna afton: Skjortor och särkar</small>
      </center>
    </div>
  </Concert>,

  <Concert
    title="Anette Wallin Trio"
    date="2026-02-27"
    cost={160}
    costYoung={85}
    img="img/program/vt2026/anette_wallin_trio.jpg"
  >
    <div className="pBody">
      <center>
        Anette Wallin Trio bjuder på visor och folkmusik från Halland i ett
        innerligt, dansant och variationsrikt program med stark närvaro och egna
        uttryck. Nu aktuella med debutalbumet <i>Över ängarna</i>.
        <br />
        <br />
        Anette Wallin – sång, fiol &amp; blockflöjt; Pers Nils Toft – klarinett
        &amp; durspel; Oskar Reuter – 12-strängad gitarr &amp; cittern.
        <br />
        <br />
        <table className="program-tabell">
          <tr>
            <td>17:30–19:15</td>
            <td>Kurs: Spelmanslaget</td>
          </tr>
          <tr>
            <td>18:00–19:30</td>
            <td>Danskurs för nybörjare</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>(se kursinfo)</small>
            </td>
          </tr>
          <tr>
            <td>18:30–19:30</td>
            <td>Dansstuga</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>
                Vals med Peter Nordqvist och Marie Schonderwaldt. Spelman Björn
                Johnsson.
              </small>
            </td>
          </tr>
          <tr>
            <td>18:30–19:30</td>
            <td>Visstuga</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>Mikael Rittri lär ut visor om ryggradslösa djur</small>
            </td>
          </tr>
          <tr>
            <td>20:00–20:50</td>
            <td>Konsert: Anette Wallin Trio</td>
          </tr>
          <tr>
            <td>20:50–23:00</td>
            <td>Spel till dans</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>Anette Wallin Trio</small>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>I pausen spelar Borås spelmanslag</small>
            </td>
          </tr>
        </table>
        <br />
        <small>Kafévärd denna afton: Polskedanslaget</small>
      </center>
    </div>
  </Concert>,

  <Concert
    title="Methera"
    date="2026-03-06"
    cost={180}
    costYoung={95}
    img="img/program/vt2026/methera.jpg"
  >
    <div className="pBody">
      <center>
        Methera är en stråkkvartett med starka rötter i den engelska
        folkmusiken. Engelska Lucy Elkiss (cello), Grace Smith (fiol), Miranda
        Rutter (altfiol) och svensk-engelska Emma Reid (fiol).
        <br />
        <br />
        Efter konserten spelar Methera till dans i en blandning av brittisk
        ceilidh, europeisk bal och svensk folkdans. Enkel dansinstruktion till
        engelska och franska danser ingår.
        <br />
        <br />
        <table className="program-tabell">
          <tr>
            <td>17:30–19:15</td>
            <td>Kurs: Spelmanslaget</td>
          </tr>
          <tr>
            <td>18:00–19:30</td>
            <td>Danskurs för nybörjare</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>(se kursinfo)</small>
            </td>
          </tr>
          <tr>
            <td>18:30–19:30</td>
            <td>Dansstuga</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>
                Peter Nordqvist och Marie Schoonderwaldt lär ut polska från
                södra Dalarna. Spelmän: Karin Westerståhl och Lennart Ehn
              </small>
            </td>
          </tr>
          <tr>
            <td>18:30–19:30</td>
            <td>Spelstuga</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>Malin Klittvall lär ut engelskor från Bohuslän</small>
            </td>
          </tr>
          <tr>
            <td>20:00–21:00</td>
            <td>Konsert: Methera</td>
          </tr>
          <tr>
            <td>21:00–23:00</td>
            <td>Spel till dans</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>Methera</small>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>I pausen spelar Torgny Lundberg</small>
            </td>
          </tr>
        </table>
        <br />
        <small>Kafévärd denna afton: Mikael med vänner</small>
      </center>
    </div>
  </Concert>,

  <Concert
    title="Heldanskväll"
    date="2026-03-13"
    cost={0}
    img="img/program/vt2026/heldanskvall.jpg"
  >
    <div className="pBody">
      <center>
        Frivillig entréavgift.
        <br />
        <br />
        En helkväll för alla dansare. Triol, Höstrusk och Västkustfolk kommer
        att spela till dans två halvtimmar var.
        <br />
        <br />
        <table className="program-tabell">
          <tr>
            <td>17:30–19:15</td>
            <td>Kurs: Spelmanslaget</td>
          </tr>
          <tr>
            <td>17:30–19:00</td>
            <td>Årsmöte</td>
          </tr>
          <tr>
            <td>20:00–23:00</td>
            <td>Spel till dans</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>Triol, Höstrusk och Västkustfolk</small>
            </td>
          </tr>
        </table>
        <br />
        <small>Kafévärd denna afton: Styrelsen + medarbetare</small>
      </center>
    </div>
  </Concert>,

  <Concert
    title="Triakel"
    date="2026-03-20"
    cost={180}
    costYoung={95}
    img="img/program/vt2026/triakel.jpg"
  >
    <div className="pBody">
      <center>
        Triakel spelar svenska folkvisor, ofta med ursprung i Jämtland eller
        Hälsingland. Musiken är lågmäld men laddad och sången är hjärtat i
        ljudbilden. Triakel består av Emma Härdelin, Kjell-Erik Eriksson och
        Janne Strömstedt.
        <br />
        <br />
        <small>
          (Emma och Kjell-Erik har viskurs resp. spelkurs 21/3, se ”kurser”.)
        </small>
        <br />
        <br />
        <table className="program-tabell">
          <tr>
            <td>17:30–19:15</td>
            <td>Kurs: Spelmanslaget</td>
          </tr>
          <tr>
            <td>18:00–19:30</td>
            <td>Tillsammansgruppen</td>
          </tr>
          <tr>
            <td>18:30–19:30</td>
            <td>Dansstuga</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>
                Emelie Ström Mattsson och Alice Carlström lär ut hambopolska
                från Oviken efter Svedåker. Spelman: Sanna Rosengren
              </small>
            </td>
          </tr>
          <tr>
            <td>18:30–19:30</td>
            <td>Visstuga</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>Annelie Westerlund lär ut visor från Västergötland</small>
            </td>
          </tr>
          <tr>
            <td>20:00–21:00</td>
            <td>Konsert: Triakel</td>
          </tr>
          <tr>
            <td>21:00–23:00</td>
            <td>Spel till dans</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>Triakel</small>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>I pausen spelar Dannito</small>
            </td>
          </tr>
        </table>
        <br />
        <small>Kafévärd denna afton: Bagaregårdens spelmanslag</small>
      </center>
    </div>
  </Concert>,

  <Concert
    title="Västra låtverkstan"
    date="2026-03-27"
    cost={160}
    costYoung={85}
    img="img/program/vt2026/vastra_latverkstan.jpg"
  >
    <div className="pBody">
      <center>
        Ungdomar från hela regionen bjuder på tretakt och rockiga riff i en
        medryckande blandning! Svängig och inspirerande konsert med unga spelmän
        under ledning av Jenny Gustafsson och Anders Ådin.
        <br />
        <br />
        <table className="program-tabell">
          <tr>
            <td>17:30–19:15</td>
            <td>Kurs: Spelmanslaget</td>
          </tr>
          <tr>
            <td>18:30–19:30</td>
            <td>Dansstuga</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>
                Polskdans från Hogdal-Lommeland med Peter Nordqvist och Marie
                Schonderwaldt. Spelman Sanna Rosengren.
              </small>
            </td>
          </tr>
          <tr>
            <td>18:30–19:30</td>
            <td>Visstuga</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>Robert Qvist lär ut visor från Norrlands landskap</small>
            </td>
          </tr>
          <tr>
            <td>20:00–21:00</td>
            <td>Konsert: Västra låtverkstan</td>
          </tr>
          <tr>
            <td>21:00–23:00</td>
            <td>Spel till dans</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>Västra låtverkstan</small>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>
                I pausen dansar vi engelska, Mats Nilsson leder dansen
              </small>
            </td>
          </tr>
        </table>
        <br />
        <small>Kafévärd denna afton: Karin med vänner</small>
      </center>
    </div>
  </Concert>,

  <Concert
    title="Wood / Risinger / Moberg"
    date="2026-04-10"
    cost={160}
    costYoung={85}
    img="img/program/vt2026/wood_risinger_moberg.jpg"
  >
    <div className="pBody">
      <center>
        Med elbas, viola d’amore och fiol bjuder Magnus Wood, Lovisa Risinger
        och Lisa Moberg in till ett nytt klanglandskap med det traditionella
        låtspelet i fokus. Under våren 2026 släpper trion sin första EP.
        <br />
        <br />
        <table className="program-tabell">
          <tr>
            <td>17:30–19:15</td>
            <td>Kurs: Spelmanslaget</td>
          </tr>
          <tr>
            <td>18:30–19:30</td>
            <td>Dansstuga</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>
                Ingela och Håkan Lindberg lär ut schottis. Spelman: Björn
                Johnsson.
              </small>
            </td>
          </tr>
          <tr>
            <td>18:30–19:30</td>
            <td>Spelstuga</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>
                Helena Wright lär ut låtar från Vardal och Land, Norge
              </small>
            </td>
          </tr>
          <tr>
            <td>20:00–20:50</td>
            <td>Konsert: Wood/Risinger/Moberg</td>
          </tr>
          <tr>
            <td>20:50–23:00</td>
            <td>Spel till dans</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>Wood/Risinger/Moberg</small>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>I pausen spelar Helena Wright</small>
            </td>
          </tr>
        </table>
        <br />
        <small>Kafévärd denna afton: Västkustfolk</small>
      </center>
    </div>
  </Concert>,

  <Concert
    title="VAK (Västanvinden trio med Agnes &amp; Klara)"
    date="2026-04-17"
    cost={160}
    costYoung={85}
    img="img/program/vt2026/vak.jpg"
  >
    <div className="pBody">
      <center>
        VAK har varit aktiva på den svenska folkmusikscenen sedan 2021 och har
        etablerat sig som en av de mest tongivande och nyskapande grupperna när
        det gäller att sammanföra dans och musik på scen.
        <br />
        <br />
        <small>(Danskurs med Agnes och Klara lördag 18/4, se ”kurser”.)</small>
        <br />
        <br />
        <b>
          OBS! Albin Myrin i VAK är tyvärr sjuk! Så det blir VAK duo istället. 
        </b>
        <br />
        <br />
        <table className="program-tabell">
          <tr>
            <td>17:30–19:15</td>
            <td>Kurs: Spelmanslaget</td>
          </tr>
          <tr>
            <td>18:30–19:30</td>
            <td>Dansstuga</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>
                Mats Nilsson och Ingegerd Sigfridsson lär ut slängpolska. Spelman: Sanna Rosengren.
              </small>
            </td>
          </tr>
          <tr>
            <td>18:30–19:30</td>
            <td>Spelstuga</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>
                Lars-Gunnar Franzén lär ut låtar från Västerdalarna och Värmland
              </small>
            </td>
          </tr>
          <tr>
            <td>20:00–21:00</td>
            <td>Konsert: VAK</td>
          </tr>
          <tr>
            <td>21:00–23:00</td>
            <td>Spel till dans</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>VAK</small>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>I pausen spelar Kristians kapell</small>
            </td>
          </tr>
        </table>
        <br />
        <small>Kafévärd denna afton: Hisingens spelmanslag</small>
      </center>
    </div>
  </Concert>,

  <Concert
    title="Spelmansstämma"
    date="2026-04-24"
    cost={0}
    img="img/program/vt2026/spelmansstamma.jpg"
  >
    <div className="pBody">
      <center>
        Frivillig entréavgift.
        <br />
        <br />
        Välkommen på spelmansstämma, vårens final på Folkmusikkaféet! Allspel,
        buskspel och spel till dans. Årets allspelshäfte finns att ladda hem här: <a href="filer/2026/allspelslatar.pdf">Allspelslåtar 2026</a>.
        <br />
        <br />
        <table className="program-tabell">
          <tr>
            <td>17:30–19:00</td>
            <td>Kurs: Spelmanslaget</td>
          </tr>
          <tr>
            <td>19:00–20:00</td>
            <td>Allspel i stora salen</td>
          </tr>
          <tr>
            <td>20:00–23:00</td>
            <td>Spel till dans i stora salen</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>
                FMK:s spelmanslag, Lei-la och Tageltrång inleder, sedan följer
                öppen spellista.
              </small>
            </td>
          </tr>
          <tr>
            <td>20:00–23:00</td>
            <td>Buskspel i resten av huset</td>
          </tr>
        </table>
        <br />
        <small>Kafévärd denna afton: Mams &amp; Paps</small>
      </center>
    </div>
  </Concert>,
];

const FadeInSection = ({ children }) => {
  const domRef = React.useRef();

  const [isVisible, setVisible] = React.useState(false);

  React.useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      // In your case there's only one element to observe:
      if (entries[0].isIntersecting) {
        // Not possible to set it back to false like this:
        setVisible(true);

        // No need to keep observing:
        observer.unobserve(domRef.current);
      }
    });

    observer.observe(domRef.current);

    if (React.isValidElement(domRef.current)) {
      return () => observer.unobserve(domRef.current);
    }
  }, []);

  return (
    <section
      ref={domRef}
      className={isVisible ? "entrySec is-visible" : "entrySec"}
    >
      {children}
    </section>
  );
};

class Program extends Component {
  styles = {
    fontSize: 15,
    fontWeight: "bold",
  };

  constructor(props) {
    super(props);
    this.state = {
      isFetching: false,
      latest: null,
    };
    this.sortArchive();
  }

  getProgram() {
    return theProgram;
  }

  sortArchive() {
    theProgram.sort((a, b) => {
      let dateDiff = a.props.date.localeCompare(b.props.date);
      if (dateDiff < 0) {
        return -1;
      } else if (dateDiff > 0) {
        return 1;
      }
      return 0;
    });
  }

  render() {
    let theProgramCopy = [...theProgram];
    let scrollIndicator = <ScrollIndicator />;

    while (theProgramCopy.length > 0) {
      let p = new Concert(theProgramCopy[0].props);
      if (!p.dateOK()) {
        theProgramCopy.shift();
      } else {
        break;
      }
    }

    if (theProgramCopy.length == 0) {
      return (
        <div>
          {openingSection}
          <center>
            <h1>Tack för denna säsong!</h1>
            Hoppas vi ses även nästa. Vi kommer snart att presentera kommande
            program.
            <br />
            <br />
            <a href="/arkiv">Vårt arkiv över tidigare kvällar som varit</a>
            <br />
            <br />
          </center>
        </div>
      );
    }

    if (theProgramCopy.length > 1) {
      let prog = [...theProgramCopy];
      let firstShow = prog.shift();
      /* All except the first one should have this swooch effect */
      let items = prog.map((concert) => (
        <FadeInSection key={concert}>{concert}</FadeInSection>
      ));
      items.unshift(<div className="is-visible">{firstShow}</div>);
      return (
        <div>
          {scrollIndicator}
          {openingSection}
          {items}
          <br />
          <center>
            <a
              style={{
                "font-size": "30px",
                border: "1px solid black",
                padding: "10px",
                "border-radius": "5px",
              }}
              href="/arkiv"
            >
              Tidigare program
            </a>
          </center>
          <br />
          <br />
          <br />
        </div>
      );
    }
    return (
      <div>
        {openingSection}
        {theProgram}
        <center>
          <a
            style={{
              "font-size": "30px",
              border: "1px solid black",
              padding: "10px",
              "border-radius": "5px",
            }}
            href="/arkiv"
          >
            Tidigare program
          </a>
        </center>
        <br />
        <br />
      </div>
    );
  }
}

export default Program;
